import { type RefObject, useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';

import { WORKSPACE_AGENT_CHOICE_CHIP_LINE_HEIGHT_PX } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentChoiceChip';

/** A label taller than this many chip lines has wrapped. */
const WRAPPED_LABEL_LINES = 1.5;

/** True when any option before Something else fills the row or wraps its label. */
export const useAnyOptionFullWidth = (containerRef: RefObject<HTMLDivElement | null>, enabled: boolean) => {
  const [anyFullWidth, setAnyFullWidth] = useState(false);

  useIsomorphicLayoutEffect(() => {
    const container = containerRef.current;

    if (!enabled || !container) {
      setAnyFullWidth(false);
      return;
    }

    const measure = () => {
      const containerWidth = container.clientWidth;
      const optionButtons = Array.from(container.querySelectorAll<HTMLElement>(':scope > [data-option-index]')).slice(
        0,
        -1,
      );

      setAnyFullWidth(
        optionButtons.some((option) => {
          const labelHeight = option.querySelector<HTMLElement>('[data-option-label]')?.offsetHeight ?? 0;

          return (
            option.offsetWidth >= containerWidth - 1 ||
            labelHeight > WORKSPACE_AGENT_CHOICE_CHIP_LINE_HEIGHT_PX * WRAPPED_LABEL_LINES
          );
        }),
      );
    };

    measure();

    const observer = new ResizeObserver(measure);

    observer.observe(container);

    return () => {
      observer.disconnect();
    };
  }, [containerRef, enabled]);

  return anyFullWidth;
};
